import React from "react";
import { useTranslation } from "react-i18next";

import { CreateNewFacilityReportForm } from "./Form";

import "./styles.scss";

interface IModalCreateNewFacilityReportProps {
  handleClose: () => void;
  handleSubmit: (payload: any) => void;
}

export const ModalCreateNewFacilityReport: React.FC<
  IModalCreateNewFacilityReportProps
> = (props) => {
  const { handleClose, handleSubmit } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityReportsPage.modalCreateNew.${key}`);

  return (
    <div className="modal modal-default modal-create-new-facility-report">
      <div className="modal-mains">
        <button className="btn-close" onClick={handleClose}></button>
        <div className="modal-mains__body">
          <div className="top-title">
            <h2>{t("create_new_report")}</h2>
          </div>
          <CreateNewFacilityReportForm
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};
